// @flow
import React from 'react';
import type { UrlBlock as UrlBlockType } from 'message-parsing';
import type { ServiceBubblePropType } from './ServiceBubblePropType';

type UrlBlockProps = {
  block: UrlBlockType,
  inline: boolean,
  serviceBubbles: ServiceBubblePropType,
  handleLinkFormat: boolean,
};

export default function UrlBlock({
  block,
  inline,
  serviceBubbles,
  handleLinkFormat,
}: UrlBlockProps) {
  // eslint-disable-line object-curly-newline
  // (because https://github.com/babel/babel-eslint/issues/513)

  if (
    serviceBubbles &&
    handleLinkFormat &&
    block.isServiceBubble &&
    block.serviceBubbleType in serviceBubbles
  ) {
    const ServiceBubble = serviceBubbles[block.serviceBubbleType];
    return (
      <ServiceBubble
        fallbackUrl={block.cleanUrl}
        inline={inline}
        {...block.serviceBubbleProperties}
      />
    );
  }
  const fallbackLink = <InlineUrlBlock block={block} handleLinkFormat={handleLinkFormat} />;
  return inline ? fallbackLink : <div>{fallbackLink}</div>;
}

type InlineUrlBlockProps = {
  block: UrlBlockType,
  handleLinkFormat: boolean,
};

function InlineUrlBlock({ block, handleLinkFormat }: InlineUrlBlockProps) {
  return (
    <a href={handleLinkFormat ? block.cleanUrl : block.url} data-test-id="service-bubble-url-block">
      {handleLinkFormat ? block.linkTitle : block.url.toString()}
    </a>
  );
}
